module.exports = __webpack_public_path__ + "static/media/sf_800_gray.1a81d08525fc37eabb9d1f35951d238a.png";